import { Component, OnInit, Renderer2, ViewChild, ElementRef, EventEmitter, Output, ChangeDetectorRef, ViewEncapsulation, Optional } from '@angular/core';
import { HubServices, ApiService } from '../../net/apiRoute';
import { UserTokenService } from '../../services/user-token.service';
import { SettingsService } from '../../services/settings.service';
import { _HttpClient } from '../../net/http.client';
import { ResponseContext, UploadResult } from '../../net/response-context.interface';
import { generateTaskId, getExtension, readerImageBase64, timeDifference } from '../utils';
import { ImConversation, MessagePack, IChatRecordResponse, MessageStatusNotice, LivePack, LiveStatusNotice, ImMailListItem, FilePack } from './model';
import { Observable, pipe, Subject, Subscription } from 'rxjs';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzMessageService } from 'ng-zorro-antd/message';
import { decodeDom2, decodeText, EMOJI_URL, MEDIA_IMG } from './emoji-picker/emojiMap';
import { debounceTime, filter, map } from 'rxjs/operators';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { RtcService } from './rtc.service';
import { NzImageService } from 'ng-zorro-antd/image';
import { SrcPipe } from '../src.pipe';
import { NzContextMenuService } from 'ng-zorro-antd/dropdown';
import { createFileDom } from './message/file-element/fileMap';
import { ChatService } from './chat.service';
import { HubConnection } from '@aspnet/signalr';
//import { HubConnection } from '@microsoft/signalr';
 
 
// import { initializeApp } from "firebase/app";
// import { getMessaging,getToken,onMessage } from "firebase/messaging";
// import { onBackgroundMessage } from "firebase/messaging/sw";
@Component({
  selector: 'app-im',
  templateUrl: './app-im.component.html',
  styleUrls: ['./app-im.component.less']
})


export class AppImComponent implements OnInit {

  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('search') searchInput;
  @ViewChild('messageTextElement', { static: false }) messageTextElement?: ElementRef;
  @ViewChild('selectImageFile', { static: false }) selectImageFile?: ElementRef;
  @ViewChild('selectFile', { static: false }) selectFile?: ElementRef;
  @ViewChild(NzTooltipDirective, { static: false }) notNulltooltip!: NzTooltipDirective;
  collapsedMenu = true;
  loadingSessionList = true;
  loadingMailList = false;
  loadingChatRecord = false;
  //当前选中的会话联系人ID
  selectSession: ImConversation;
  //右键菜单会话联系人
  selectMenuSession: ImConversation;
  //连接对象
  connection: HubConnection;
  searchEditing: boolean;
  textFocus: boolean;
  //输入消息文本
  messageText: string = "";
  //分页信息
  pageInfo = { pageIndex: 0, pageSize: 10, dataCount: 0, totalPage: 0 };
  //聊天记录
  chatRecordData: Array<MessagePack> = [];
  //会话列表
  sessionList: Array<ImConversation> = [];
  //联系人列表
  mailList: Array<ImMailListItem> = [];
  //当前选中的联系人详情
  selectMailItem: ImMailListItem;
  uploadUrl = ApiService.UploadFile;
  //最后一次滚动条位置
  lastscrollHeight = 0;
  //全局未读数量
  TotalUnreadNumber = 0;
  //接受图片格式
  acceptImage = ['image/png', 'image/gif', 'image/jpg', 'image/bmp', 'image/jpeg'];
  acceptImageStr = ".png,.gif,.jpg,.bmp,.jpeg";
  showEmojiPicker: boolean = false;
  //输入框防抖动
  private inputSubject = new Subject<any>();
  //输入框输入订阅
  private inputSubscription: Subscription;
  //最大输入限制
  inputMaxLength = 2000;
  constructor(private cd: ChangeDetectorRef, private message: NzMessageService, public http: _HttpClient, public tokenSerivce: UserTokenService,
    public settings: SettingsService, public chatService: ChatService, public rtcService: RtcService, private nzImageService: NzImageService,
    private nzContextMenuService: NzContextMenuService) {


  }



  canTo: boolean = true;

  ngOnInit() {
    this.menuClick(1);
    this.registerSignalR();
    //this.installFirebaseMessageNotice();
    //输入框延时订阅
    this.inputSubscription = this.inputSubject.pipe(
      debounceTime(50)
    ).subscribe(e => {
      if (e.type == 'input') {
        this.messageText = decodeDom2(this.messageTextElement.nativeElement.innerHTML);
        console.log(this.messageText);
      }

    });
  }
  ngOnDestroy(): void {
    this.connection?.stop();
    this.connection = null;
    this.inputSubscription?.unsubscribe();
  }

  // installFirebaseMessageNotice() {
  
  //     // Your web app's Firebase configuration
  //     // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  //     const firebaseConfig = {
  //       apiKey: "AIzaSyCyQL3VJKqAwGQ8eJlpp9M1ceRdsdUGLj4",
  //       authDomain: "mainuo-notices.firebaseapp.com",
  //       projectId: "mainuo-notices",
  //       storageBucket: "mainuo-notices.appspot.com",
  //       messagingSenderId: "329823214329",
  //       appId: "1:329823214329:web:19e8fde9c2b500ea58e028",
  //       measurementId: "G-F83GKYGJV7"
  //     };

  //     // Initialize Firebase
  //     const app = initializeApp(firebaseConfig);
  //     const messaging = getMessaging();

    
     
  //     getToken(messaging, { vapidKey: 'BBV_xUGxNDM7AzQCsezYIjmhbSXGBVndC7ByZNCVcgp1PELa97daooUFZ6aRDzC-wa8KTWcWFzZOoEW3wv88KjQ' }).then((currentToken) => {
  //       if (currentToken) {
  //         // Send the token to your server and update the UI if necessary
  //         // ...
  //         console.log(currentToken)
  //       } else {
  //         // Show permission request UI
  //         console.log('No registration token available. Request permission to generate one.');
  //         // ...
  //       }
  //     }).catch((err) => {
  //       console.log('An error occurred while retrieving token. ', err);
  //       // ...
  //     });

  //     onMessage(messaging, (payload) => {
  //       console.log('222222222222222222222222222222222222222');

  //     });
  // }

  async registerSignalR() {
    this.connection = await this.chatService.connection;
    this.conectionOk();
    this.connection.on("broadcastMessage", (n: MessagePack) => {
      var sessionId = n.ObjectType == 0 ? n.SendUserId : n.ReceiveId;
      if (n.SendUserId == this.settings.user.userId) {
        return;
      }
      var item = this.sessionList.find(n => n.ObjectId == sessionId);
      if (!item) {
        this.connection.invoke("GetMailInfo", this.settings.user.userId, sessionId).then((n: ResponseContext<ImConversation>) => {
          this.sessionList.unshift(n.Result)
        });
      } else {
        this.sessionGoTop(sessionId, n.MessageText, n.SendTime);
        if (this.selectSession && this.selectSession.ObjectId == sessionId) {
          this.connection.send("UpdateToRead", this.selectSession.ObjectId);
          this.chatRecordData.push(n);
          // this.scrollToBottom();
        } else {
          if (!item) return;
          item.UnreadNumber += 1;
          this.updateTotalUnreadNumber();
        }
      }
    });


    this.connection.on("chatRecord", (n: ResponseContext<IChatRecordResponse>) => {
      this.lastscrollHeight = document.getElementById("chatContext").scrollHeight;
      var c = n.Result.data;
      this.pageInfo.dataCount = n.Result.pager.dataCount;
      var page = (this.pageInfo.dataCount + this.pageInfo.pageSize - 1) / this.pageInfo.pageSize;
      this.pageInfo.totalPage = parseInt(page.toString());
      c.forEach(n => {
        this.chatRecordData.unshift(n);
      });

      this.loadingChatRecord = false;
      if (this.pageInfo.pageIndex == 1) {
        //this.scrollToBottom();
      } else {
        this.cd.detectChanges();
        var location = document.getElementById("chatContext").scrollHeight - this.lastscrollHeight;
        document.getElementById("chatContext").scrollTop = (location);//+50
      }

    });

    this.connection.on("broadcastStatus", (c: ResponseContext<MessageStatusNotice>) => {
      var m = this.chatRecordData.find(n => n.PackageId == c.Result.PackageId);
      if (m) {
        m.SendStatus = 1;
        m.SendTime = c.Result.SendTime;
        m.Id = c.Result.MessageRecordId;
        var s = this.sessionList.find(n => n.ObjectId == m.ReceiveId);
        s.SendTime = m.SendTime;
        s.LastMessageId = c.Result.MessageRecordId;
        s.MessageText = m.MessageText;
      }
    })


    this.rtcService.setuphubConnection(this.connection);
  }

  updateTotalUnreadNumber() {
    this.TotalUnreadNumber = this.sessionList.reduce((acc, item) => acc + Number(item.UnreadNumber), 0);
  }

  conectionOk() {
    //获取聊天会话列表
    this.connection.invoke("GetConversationlist").then((n: ResponseContext<Array<ImConversation>>) => {
      this.sessionList = n.Result;
      this.loadingSessionList = false;
      this.updateTotalUnreadNumber();
    });
    //获取通讯录列表
    this.connection.invoke("GetMaillist").then((n: ResponseContext<Array<ImMailListItem>>) => {
      this.mailList = n.Result;
      console.log(n);
    });
  }

  checkCurrentMailInfo(m: ImMailListItem) {
    if (!this.selectMailItem) {
      return false;
    }
    return m == this.selectMailItem;
  }
  mailItemClick(mailInfo) {
    this.selectMailItem = mailInfo;
  }

  addSession(objectType) {
    var session = this.sessionList.find(n => n.ObjectId == this.selectMailItem.Data.UserId);
    if (session) {
      this.sessionGoTop(session.ObjectId, session.MessageText, session.SendTime);
      return;
    }
    session = {
      Id: "",
      UserId: this.settings.user.userId,
      ObjectId: this.selectMailItem.Data.UserId,
      ObjectType: objectType,
      LastMessageId: "",
      UnreadNumber: 0,
      MessageText: "",
      SendTime: "",
      HeadImg: this.selectMailItem.Data.HeadImg,
      Name: this.selectMailItem.Data.UserNick,
    };
    this.sessionList.unshift(session);
    this.settings.messageBox.selectIndex = 1;
    this.conversationSessionClick(session);

  }
  onSearchFocus() {
    this.searchEditing = true;
  }

  onSearchBlur() {
    this.searchEditing = false;
  }

  onTextareaFocus() {
    this.textFocus = true;

  }

  onTextareaBlur() {
    this.textFocus = false;
  }

  textareaInput(e: KeyboardEvent) {
    if (e.key == "Backspace") {
      if (this.messageTextElement.nativeElement.lastChild?.nodeName != "BR") {
        var br = document.createElement('br');

        this.messageTextElement.nativeElement.append(br);
      }
    }
    this.inputSubject.next({ type: 'input' });
  }

  onTextKeyDown(e: KeyboardEvent) {
    if (e.ctrlKey && e.key == 'KeyA') {

      return true;
    }
    setTimeout(() => {
      if (this.messageTextElement.nativeElement.innerText.length > this.inputMaxLength) {
        this.messageTextElement?.nativeElement.focus();
        document.execCommand("Delete", false, null);
        e.returnValue = false;
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        this.message.create('info', '最大限制字数' + this.inputMaxLength);
        return false;
      }
    }, 10);
    if (e.key == "Enter") {
      this.sendTextMessage();
      return false;
    }

  }

  menuClick(index) {
    this.settings.setMessageBox("selectIndex", index);
    if (index == 1) {
      this.scrollToBottom();
    }
  }

  max() {
    this.settings.setMessageBox("max", !this.settings.messageBox.max);
    this.onChange.emit({ type: 'max' });
  }

  hide() {

    this.settings.setMessageBox("show", false);
  }

  send(cmp: MessagePack) {
    if (cmp.ObjectType == 0) {
      this.connection.send("SendMessage", cmp);
    } else if (cmp.ObjectType == 1) {
      this.connection.send("SendGroupMessage", cmp);
    }

    this.sessionGoTop(cmp.ReceiveId, cmp.MessageText, "");
    this.messageText = "";
    this.messageTextElement?.nativeElement.focus();
    this.messageTextElement.nativeElement.innerHTML = "";
  }

  sendTextMessage() {
    this.notNulltooltip.hide();
    if (!this.messageText.trimStart()) {
      this.notNulltooltip.show();
      setTimeout(() => {
        this.notNulltooltip.hide();
      }, 2000);
      return;
    }
    var packList = decodeText(this.messageText);
    packList.forEach(n => {
      var context = n.value;
      var cmp: MessagePack = {
        PackageId: generateTaskId(),
        Type: n.type,
        MessageText: context,
        ReceiveId: this.selectSession.ObjectId,
        SendUserId: this.settings.user.userId,
        SendName: this.settings.user.name,
        SendStatus: 0,
        SendUserHeadImg: this.settings.user.avatar,
        ObjectType: this.selectSession.ObjectType,
        IsMe: true,
        MediaUrl: n.type != 0 ? context : null
      };
      this.chatRecordData.push(cmp);
      this.scrollToBottom(true);
      if (n.type == 1) {
        cmp.MessageText = '[图片]';
        this.uploadMedia(cmp);
      } else if (n.type == 5) {
        cmp.MessageText = '[文件]';
        var fileCach = this.fileclipCach.find(c => c.pack.Id == n.value);
        cmp.Data = fileCach.pack;
        this.uploadMedia(cmp, fileCach.file);
      }
      else {
        this.send(cmp);
      }

    });
  }
  uploadMedia(cmp: MessagePack, file?: File) {
    var data = new FormData();
    data.append("foldername", 'chat');
    debugger;
    if (cmp.Type == 1) {
      var blob = this.dataURLtoBlob(cmp.MediaUrl);
      var name = generateTaskId() + "." + blob.type.replace('image/', '');
      data.append("file", blob, name);
    } else {
      var name = generateTaskId() + cmp.Data.Extension;
      data.append("file", file, name);
    }
    var cp = cmp;
    this.http.post(this.uploadUrl, data, false, null, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      filter((f) => {
        switch (f.type) {
          case HttpEventType.UploadProgress: {
            cp.Progress = Math.round(100 * f.loaded / f.total);
            break;
          }
          case HttpEventType.Response: {
            return true;
          }
        }
        return false;
      }),
      map((n: HttpResponse<any>) => n.body)
    ).subscribe((res: ResponseContext<Array<UploadResult>>) => {
      if (res.Status == 1) {
        cmp.MediaUrl = res.Result[0].shortPath;
        this.send(cmp);
      }

    });
  }
  dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  getConversationList() {
    this.loadingSessionList = true;
    this.http.get(HubServices.API_ConversationList).subscribe((n: ResponseContext<Array<ImConversation>>) => {
      this.sessionList = n.Result;
      this.loadingSessionList = false;
    });

  }
  sessionMenu($event: MouseEvent, menu, item: ImConversation) {
    if (!item) return;
    this.selectMenuSession = item;
    this.nzContextMenuService.create($event, menu);
  }
  conversationSessionClick(item: ImConversation) {
    if (this.selectSession == item) {
      return;
    }
    this.selectSession = item;
    this.pageInfo.pageIndex = 1;
    this.chatRecordData = [];
    this.loadQueryChatRecord();
    if (this.selectSession.UnreadNumber > 0) {
      this.connection.send("UpdateToRead", item.ObjectId);
    }
    this.selectSession.UnreadNumber = 0;
    this.updateTotalUnreadNumber();
    this.canTo = true;
    this.cd.detectChanges();
    this.messageTextElement?.nativeElement.focus();
  }

  sessionMenuItemClick(e) {
    this.sessionGoTop(this.selectMenuSession.ObjectId);
  }

  deleteSession() {
    this.connection.invoke("DeleteConversation", this.selectMenuSession.ObjectId).catch(e => {
      this.message.create('error', '删除失败：' + e);
    }).then(m => {
      var index = this.sessionList.findIndex(n => n.Id == this.selectMenuSession.Id);
      this.sessionList.splice(index, 1);
      if (this.selectSession?.Id == this.selectMenuSession.Id) {
        this.selectSession = null;
      }
      this.selectMenuSession = null;

    });
  }
  sessionGoTop(sessionId, text?, time?) {
    var index = this.sessionList.findIndex(c => c.ObjectId == sessionId);
    if (index != -1) {
      if (text) this.sessionList[index].MessageText = text;
      if (time) this.sessionList[index].SendTime = time;
      this.sessionList.unshift(this.sessionList.splice(index, 1)[0]);
    }
  }

  morePage() {
    if (this.pageInfo.totalPage > this.pageInfo.pageIndex) {
      this.loadingChatRecord = true;
      setTimeout(() => {
        this.pageInfo.pageIndex += 1;
        this.loadQueryChatRecord();
      }, 500);
    }
  }
  onscroll(e) {
    var top = e.target.scrollTop;
    if (top == 0 && this.pageInfo.totalPage > this.pageInfo.pageIndex && this.chatRecordData.length > 0) {

      this.morePage();
    }
  }
  onmousewheel(e) {
    this.canTo = false;
    var dom = document.getElementById("chatContext");
    if (e.wheelDelta < 0 && dom.scrollHeight > dom.clientHeight && (dom.scrollTop + dom.clientHeight) === dom.scrollHeight) {
      this.canTo = true;
    }

  }

  scrollToBottom(force?: boolean) {
    this.cd.detectChanges();
    var dom = document.getElementById("chatContext");
    if (!dom) {
      return;
    }
    if (((dom.scrollTop + dom.clientHeight) != dom.scrollHeight && this.canTo) || force) {
      dom.scrollTo({ left: 0, top: dom.scrollHeight })

    }
  }


  ngAfterViewChecked() {
    if (this.settings.messageBox.selectIndex == 1 && this.pageInfo.pageIndex == 1 && this.canTo) {
      this.scrollToBottom();
    }

  }

  loadQueryChatRecord() {
    var query = {
      pagerInfo: this.pageInfo,
      queryJson: {
        UserId: this.settings.user.userId,
        ObjectId: this.selectSession.ObjectId,
        ObjectType: this.selectSession.ObjectType
      },
      sortInfo: null
    };
    this.connection.send("QueryChatRecord", query);

  }

  showStatus(item: MessagePack, index): boolean {
    if (index == 0) {
      return true;
    }
    var time = this.chatRecordData[index - 1].SendTime;
    if (!time || !item.SendTime) {
      return false;
    }
    var exp = timeDifference(time, item.SendTime);
    return exp > 24;
  }

  checkCurrentSession(value: ImConversation): boolean {
    if (!this.selectSession) {
      return false;
    }
    return value == this.selectSession;
  }

  onSelectImage() {
    this.selectImageFile.nativeElement.click();
  }

  onSelectFile() {
    this.selectFile.nativeElement.click();
  }
  uploadImage(e) {
    var that = this;
    var file: File = e.target.files[0];
    var ext = getExtension(file.name);
    if (this.acceptImageStr.split(',').indexOf(ext) == -1) {
      this.message.create('warning', `请选择图片`);
      that.messageTextElement.nativeElement.focus();
      return;
    }

    var reader = new FileReader();
    reader.onload = function (e) {
      var img = document.createElement('img'); //创建img节点
      img.setAttribute('img-key', "[" + MEDIA_IMG + "]");
      img.src = e.target.result.toString();
      img.setAttribute("filename", file.name);
      if (document.activeElement != that.messageTextElement.nativeElement) {
        that.messageTextElement.nativeElement.focus();
      }
      document.execCommand('inserthtml', false, img.outerHTML);
    }
    reader.readAsDataURL(file as any)
    this.inputSubject.next({ type: 'input' });

  }

  async uploadFile(e) {
    for (let index = 0; index < e.target.files.length; index++) {
      var file: File = e.target.files[index];
      var pack: FilePack = {
        Id: generateTaskId(),
        FileName: file.name,
        FileSize: file.size,
        Extension: getExtension(file.name)
      };

      var cmp: MessagePack = {
        PackageId: generateTaskId(),
        Type: 5,
        MessageText: '[文件]',
        ReceiveId: this.selectSession.ObjectId,
        SendUserId: this.settings.user.userId,
        SendName: this.settings.user.name,
        SendStatus: 0,
        SendUserHeadImg: this.settings.user.avatar,
        ObjectType: this.selectSession.ObjectType,
        IsMe: true,
        Data: pack
      };

      //如果是图片
      if (this.acceptImageStr.split(',').indexOf(pack.Extension) != -1) {
        cmp.Type = 1;
        cmp.MessageText = '[图片]';
        cmp.Data = null;
        cmp.MediaUrl = await readerImageBase64(file);
      }
      this.chatRecordData.push(cmp);
      this.scrollToBottom(true);
      this.uploadMedia(cmp, file);
    }
  }

  //execCommand('inserthtml', loadingHtml);
  emojiClick(e: { key: string, value: string }) {
    this.showEmojiPicker = false;
    var node = document.createElement("img");
    node.setAttribute('img-key', e.key);
    node.src = EMOJI_URL + e.value;
    document.execCommand('inserthtml', true, node.outerHTML);
    this.inputSubject.next({ type: 'input' });
  }

  fileclipCach: Array<{ pack: FilePack, file: File }> = [];
  onPaste(e: ClipboardEvent) {
    this.fileclipCach = [];
    for (let index = 0; index < e.clipboardData.items.length; index++) {
      const item = e.clipboardData.items[index];
      if (this.acceptImage.indexOf(item.type) != -1) {
        var reader = new FileReader()
        var file = item.getAsFile();
        reader.onload = function (e) {
          var img = document.createElement('img'); //创建img节点
          img.setAttribute('img-key', "[" + MEDIA_IMG + "]");
          img.src = e.target.result.toString();
          img.setAttribute("filename", file.name)
          document.execCommand('inserthtml', false, img.outerHTML);
        }
        reader.readAsDataURL(file)
        this.inputSubject.next({ type: 'input' });
      }
      else if (item.type == 'text/html') {
        return false;
      }
      else if (item.type == 'text/plain') {
        return true;
      }
      else {
        var _file: File = item.getAsFile();
        var _pack: FilePack = {
          Id: generateTaskId(),
          FileName: _file.name,
          FileSize: _file.size,
          Extension: getExtension(_file.name)
        };
        createFileDom(_pack.Id, _file);
        this.fileclipCach.push({
          pack: _pack,
          file: _file
        });
      }
    }
    return false;
  }


  shareScreen() {
    if (this.settings.liveInfo.Screen) {
      this.message.create('info', `正在直播，请稍后再试`);
      return;
    }
    var opt = { audio: true, screen: false, camera: true };
    this.settings.setLiveRoomInfo("Show", true);
    this.rtcService.createRoom(opt, 0).then((result) => {
      if (!opt.camera && !opt.screen && !opt.audio) {
        this.settings.setLiveRoomInfo("Show", false);
        return;
      }
      var livePack: LivePack = {
        PackageId: generateTaskId(),
        UserId: this.settings.user.userId,
        Title: this.settings.user.name + '的直播',
        Camera: opt.camera,
        Audio: opt.audio,
        Screen: opt.screen,
        IsCreator: true
      };
      this.createLive(livePack);
    });


  }
  createLive(livePack: LivePack) {
    this.connection.invoke("CreateLive", livePack).then((result: ResponseContext<LiveStatusNotice>) => {
      livePack.Id = result.Result.LiveInfo.Id;
      livePack.RoomId = result.Result.LiveInfo.RoomId.toString();
      this.settings.setLiveRoomInfo(result.Result.LiveInfo);
      this.sendLiveMessage(livePack);
    }, (err) => {
      console.log(err);
    });

  }
  sendLiveMessage(livePack: LivePack) {
    var cmp: MessagePack = {
      PackageId: generateTaskId(),
      Type: 4,
      MessageText: '[直播]',
      ReceiveId: this.selectSession.ObjectId,
      SendUserId: this.settings.user.userId,
      SendName: this.settings.user.name,
      SendStatus: 0,
      SendUserHeadImg: this.settings.user.avatar,
      ObjectType: this.selectSession.ObjectType,
      IsMe: true,
      Data: livePack,
      RelationId: livePack.RoomId.toString(),
      LiveStatus: 1
    };
    this.chatRecordData.push(cmp);
    this.scrollToBottom(true);
    this.send(cmp);
  }

  onJoinLive(cmp: MessagePack) {
    if (this.settings.liveInfo.Show || cmp.SendUserId == this.settings.user.UserId) {
      this.message.create('info', "正在直播中");
      return;
    }
    if (cmp.LiveStatus == 0) {
      this.message.create('info', "直播已结束");
      return;
    }
    if (cmp.Type == 4) {
      var data: LivePack = {
        PackageId: generateTaskId(),
        UserId: cmp.Data.UserId,
        RoomId: cmp.RelationId
      };
      this.connection.invoke("JoinRoom", data).then((result: ResponseContext<LiveStatusNotice>) => {
        if (result.Result.LiveInfo.Status == 0) {
          this.message.create('info', "直播已结束");
          cmp.LiveStatus = 0;
          return;
        }
        this.settings.setLiveRoomInfo("Show", true);
        this.settings.setLiveRoomInfo(result.Result.LiveInfo);
        this.rtcService.readyConnection(result.Result.LiveInfo);
      });
    }
  }
  onImgPreview(cmp: MessagePack) {
    var nzImages = [];
    var srcPip = new SrcPipe();
    this.chatRecordData.filter(n => n.Type == 1).forEach(n => {
      nzImages.push({
        src: srcPip.transform(n.MediaUrl),
        Id: n.Id
      });
    });
    var index = nzImages.findIndex(n => n.Id == cmp.Id);
    var viewRef = this.nzImageService.preview(nzImages, { nzZoom: 1, nzRotate: 0 });
    viewRef.switchTo(index)
  }

  onMove(e) {
    this.settings.setMessageBox("left", e.left);
    this.settings.setMessageBox("top", e.top);
    this.settings.setMessageBox("bottom", e.bottom);
    this.settings.setMessageBox("right", e.right);
    this.settings.setMessageBox("lastLeft", e.left);
    this.settings.setMessageBox("lastTop", e.top);
    this.settings.setMessageBox("lastBottom", e.bottom);
    this.settings.setMessageBox("lastRight", e.right);
  }
}
